/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { CmsDetailedDto } from '../models/cms-detailed-dto';
import { CmsDto } from '../models/cms-dto';
import { CmsGetAllReq } from '../models/cms-get-all-req';
import { CmsGetAllResp } from '../models/cms-get-all-resp';

@Injectable({
  providedIn: 'root',
})
export class CmsService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation cmsPut
   */
  static readonly CmsPutPath = '/cms';

  /**
   * Update and Create Cms
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `cmsPut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  cmsPut$Response(params: {
    body: CmsDto
  }): Observable<StrictHttpResponse<CmsDto>> {

    const rb = new RequestBuilder(this.rootUrl, CmsService.CmsPutPath, 'put');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CmsDto>;
      })
    );
  }

  /**
   * Update and Create Cms
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `cmsPut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  cmsPut(params: {
    body: CmsDto
  }): Observable<CmsDto> {

    return this.cmsPut$Response(params).pipe(
      map((r: StrictHttpResponse<CmsDto>) => r.body as CmsDto)
    );
  }

  /**
   * Path part for operation cmsGetAll
   */
  static readonly CmsGetAllPath = '/cms';

  /**
   * Get all cms
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `cmsGetAll()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  cmsGetAll$Response(params: {

    /**
     * pagination load page
     */
    page?: number;
    body: CmsGetAllReq
  }): Observable<StrictHttpResponse<CmsGetAllResp>> {

    const rb = new RequestBuilder(this.rootUrl, CmsService.CmsGetAllPath, 'post');
    if (params) {
      rb.query('page', params.page, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CmsGetAllResp>;
      })
    );
  }

  /**
   * Get all cms
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `cmsGetAll$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  cmsGetAll(params: {

    /**
     * pagination load page
     */
    page?: number;
    body: CmsGetAllReq
  }): Observable<CmsGetAllResp> {

    return this.cmsGetAll$Response(params).pipe(
      map((r: StrictHttpResponse<CmsGetAllResp>) => r.body as CmsGetAllResp)
    );
  }

  /**
   * Path part for operation cmsGet
   */
  static readonly CmsGetPath = '/cms/{uuid}';

  /**
   * Get a cms
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `cmsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  cmsGet$Response(params: {

    /**
     * Cms uuid
     */
    uuid: string;
  }): Observable<StrictHttpResponse<CmsDetailedDto>> {

    const rb = new RequestBuilder(this.rootUrl, CmsService.CmsGetPath, 'get');
    if (params) {
      rb.path('uuid', params.uuid, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CmsDetailedDto>;
      })
    );
  }

  /**
   * Get a cms
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `cmsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  cmsGet(params: {

    /**
     * Cms uuid
     */
    uuid: string;
  }): Observable<CmsDetailedDto> {

    return this.cmsGet$Response(params).pipe(
      map((r: StrictHttpResponse<CmsDetailedDto>) => r.body as CmsDetailedDto)
    );
  }

  /**
   * Path part for operation cmsDelete
   */
  static readonly CmsDeletePath = '/cms/{uuid}';

  /**
   * Delete a cms
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `cmsDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  cmsDelete$Response(params: {

    /**
     * Cms uuid delete
     */
    uuid: string;
  }): Observable<StrictHttpResponse<{
'success'?: boolean;
}>> {

    const rb = new RequestBuilder(this.rootUrl, CmsService.CmsDeletePath, 'delete');
    if (params) {
      rb.path('uuid', params.uuid, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<{
        'success'?: boolean;
        }>;
      })
    );
  }

  /**
   * Delete a cms
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `cmsDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  cmsDelete(params: {

    /**
     * Cms uuid delete
     */
    uuid: string;
  }): Observable<{
'success'?: boolean;
}> {

    return this.cmsDelete$Response(params).pipe(
      map((r: StrictHttpResponse<{
'success'?: boolean;
}>) => r.body as {
'success'?: boolean;
})
    );
  }

}
